import React, {PureComponent, useEffect, useRef, useState} from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import { GetAgendaUserQuery, GetAgendaUserQueryVariables, UsersByComIdQuery, UsersByComIdQueryVariables } from '../../graphql/API';
import { getAgendaUser, usersByComId } from './queries';
import { useLazyQuery, useQuery } from '@apollo/client';
import { useParams } from "react-router-dom";
import Image from 'react-bootstrap/Image';
import Stack from 'react-bootstrap/Stack';
import { useTranslation } from 'react-i18next';
import { Button, Container, Form, InputGroup, Modal, Spinner } from 'react-bootstrap';
import CustomModal from '../../components/Modals/CustomModal';
import { useFieldArray, useForm } from 'react-hook-form';
import { IoAddCircle, IoTrash } from 'react-icons/io5';
import axios from 'axios';
import Sidebar from '../services/Sidebar';

const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

const createWorkers = async (emails: string[], comId: string) => {
  try {
    // console.log("POST", emails);
    const response = await axios.post("/api/create_workers", {
      comId: comId,
      emails: emails,
    });

    // console.log("create Worker:", response.data);
    return response.data; // Retourne le client token
  } catch (error) {
    console.error("Error when getting worker comId :", error);
    return null;
  }
};

const getWorkers = async (comId: string) => {
  try {
    const response = await axios.post("/api/get_workers", {
      comId: comId,
    });

    // console.log("get Workers:", response.data);
    return response.data; // Retourne le client token
  } catch (error) {
    console.error("Error when getting workers :", error);
    return null;
  }
};

const deleteWorker = async (comId: string, email: string) => {
  try {
    const response = await axios.post("/api/delete_worker", {
      comId: comId,
      email: email,
    });

    // console.log("remove Worker:", response.data);
    return response.data; // Retourne le client token
  } catch (error) {
    console.error("Error when getting workers :", error);
    return null;
  }
};

type SignUpData = {
  // email: string;
  emails: { email: string }[];
};

const CreateWorkersView = () => {
  const { t } = useTranslation();
  const {userId: AuthUserId} = useAuthContext();
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const [maxWorkers, setMaxWorkers] = useState(0);
  const [workers, setWorkers] = useState([]);
  const {register, control, handleSubmit, watch, reset, formState: { errors }} = useForm<SignUpData>({defaultValues: { emails: [{ email: "" }] },});
  const { fields, append, remove } = useFieldArray({
    control,
    name: "emails",
  });

  const {data: data, loading, error, refetch, fetchMore} = useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
      {variables: {userId: AuthUserId}});

  const [fetchUsers, {data: dataUsers, loading: loadingUsers, error: errorUsers, refetch: refetchUsers, fetchMore: fetchMorreUsers}] = useLazyQuery
    <UsersByComIdQuery, UsersByComIdQueryVariables>(usersByComId);

  const user = data?.getAgendaUser;
  const users = dataUsers?.usersByComId.items || [];

  useEffect(() => {
    document.title = t('title.addWorkers');
  }, []);

  const callWorkers = async (user: any) => {
    const workers = await getWorkers(user.comId)
    // console.log('workers', workers);
    if (workers.emails) {
      setWorkers(workers.emails);
    }
  }

  useEffect(() => {
    if (!user) return;
    if (!user.comId) return;
    if (!user.com) return;
    callWorkers(user);
    fetchUsers({variables: {comId: user.comId}}); //, filter:{suspended: {eq: false}}}});
    switch (user.com.account_type) {
      case "Free":
        setMaxWorkers(10);
        break;
      case "Starter":
        setMaxWorkers(10);
        break;
      case "Essential":
        setMaxWorkers(20);
        break;
      case "Plus":
        setMaxWorkers(30);
        break;
      case "Advanced":
        setMaxWorkers(40);
        break;
      case "Pro":
        setMaxWorkers(50);
        break;
      case "Business":
        setMaxWorkers(80);
        break;
      case "Premium":
        setMaxWorkers(100);
        break;
      case "Elite":
        setMaxWorkers(150);
        break;
      case "Ultimate":
        setMaxWorkers(200);
        break;
      case "Infinite":
        setMaxWorkers(100000);
        break;
      default:
        setMaxWorkers(10);
        break;
    }
    // if (user.com.account_type == "Starter") {
    //   setMaxWorkers(10);
    // }
  }, [user]);

  if (!user || !users) {
    // if (loading || loadingUsers || loadingShift) {
    // if (loading || loadingUsers || loadingShift || !users || !shifts) { // need to keep it like that to load all before the loading stop
    return (
        <div className="spinnerContainer">
            {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };

  const removeWorker = async (comId: string, email: string) => {
    const match = users.some(u => u.email == email);
    // console.log(match)
    if (!match) {
      const response = await deleteWorker(comId, email);
      // console.log('response', response);
      window.location.reload();
    } else {
      setContentModal(<>
        <Modal.Header closeButton>
          <Modal.Title>{t('worker.delete_error')}</Modal.Title>
        </Modal.Header>
  
        <Modal.Body>
          <p>{t(`worker.delete_error_message`)}</p>
        </Modal.Body></>);
      // setLinkModal(t('link.add_worker'));
      setShowCustomModal(true);
    }
  }

  const onRegisterPressed = async (data: SignUpData) => {
    // console.log('data',data);
      if (loadingForm) {
        return;
      };
      setLoadingForm(true);
      try {
        const emails = data.emails
        .map((entry) => entry.email.trim()) // Supprime les espaces
        .filter((email) => email.length > 0); // Ignore les champs vides

        // console.log("Emails à inscrire :", emails);

        if (emails.length === 0) {
          // alert("Veuillez entrer au moins un email !");
          setContentModal(<>
            <Modal.Header closeButton>
              <Modal.Title>{t('worker.create_title')}</Modal.Title>
            </Modal.Header>
      
            <Modal.Body>
              <p>{t('worker.atleast_one_email')}</p>
            </Modal.Body></>);
          // setLinkModal(t('link.add_worker'));
          setShowCustomModal(true);
          setLoadingForm(false);
          return;
        }
        // console.log("Emails à inscrire :", emails);
        // console.log("max", workers.length + emails.length);
        if (user.comId) {
          if (user.com.account_type != "" && user.com.account_type != "Infinite") {
            if ((workers.length + emails.length) > maxWorkers) {
              setContentModal(<>
                <Modal.Header closeButton>
                  <Modal.Title>{t('worker.create_title')}</Modal.Title>
                </Modal.Header>
          
                <Modal.Body>
                  <p>{t(`worker.create_max_10_workers`)}</p>
                </Modal.Body></>);
              // setLinkModal(t('link.add_worker'));
              setShowCustomModal(true);
              return;
            }
          }
          const response = await createWorkers(emails, user.comId);
          // console.log("RESPONSE", response);
          if (response.status == "success") {
            if (response.workers.length > 0) {
              setContentModal(<>
                <Modal.Header closeButton>
                  <Modal.Title>{t('worker.create_title')}</Modal.Title>
                </Modal.Header>
          
                <Modal.Body>
                  <p>{t('worker.create_message')}</p>
                  {response.workers.map((email: string, index: number) => {
                    return <p key={index}>{email}</p>
                  })}
                </Modal.Body></>);
              // setLinkModal(t('link.add_worker'));
              setShowCustomModal(true);
            } else {
              setContentModal(<>
                <Modal.Header closeButton>
                  <Modal.Title>{t('worker.create_title')}</Modal.Title>
                </Modal.Header>
          
                <Modal.Body>
                  <p>{t('worker.create_no_new_worker')}</p>
                </Modal.Body></>);
              // setLinkModal('/cognito/confirmEmail');
              setShowCustomModal(true);
            }
          } else {
            setContentModal(<>
              <Modal.Header closeButton>
                <Modal.Title>{t('worker.create_error')}</Modal.Title>
              </Modal.Header>
        
              <Modal.Body>
                <p>{response.message}</p>
              </Modal.Body></>);
            // setLinkModal('/cognito/confirmEmail');
            setShowCustomModal(true);
          }
        }
      } catch (error) {
        // console.log('Registration Error : ', error);
        setContentModal(<>
          <Modal.Header closeButton>
            <Modal.Title>{t('worker.create_error')}</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            <p>{(error as Error).message}.</p>
          </Modal.Body></>);
        setShowCustomModal(true);
        // alert("Registering error: " + (error as Error).message);
      } finally {
        setLoadingForm(false);
        reset();
      };
    };
  
  // const mergedWorkers = [...users, ...workers.filter(p => !users.some(n => n.email === p.email))];
  return (
    <>
      <CustomModal
        show={showCustomModal}
        onHide={() => {
          setShowCustomModal(false);
          window.location.reload();
        }}
        link={linkModal}
        children={contentModal}
        // animation={true}
      />
      <div className="d-flex">
        <Sidebar user={user} />
        <div className="users-container w-100">
          <Form className="register-form">
            <h2 className="text-center">{t('worker.addWorkerForm')}</h2>
            <Container className="">
              {fields.map((field, index) => (
                <div key={field.id} style={{ marginBottom: "15px" }}>
                <InputGroup key={field.id} style={{ marginBottom: "5px" }}>
                  <Form.Control
                    placeholder={t('signup.email')}
                    aria-label="Email"
                    aria-describedby="basic-addon1"
                    className="d-inline me-lg-2"
                    {...register(`emails.${index}.email` as const, {
                      // required: t('worker.email_required'),
                      pattern: {
                        value: EMAIL_REGEX,
                        message: t('worker.email_invalid')
                      }
                    })}
                    // name="email"
                  />
                  {fields.length > 1 && (
                    // <Button variant="danger" onClick={() => remove(index)}>
                      <IoTrash size={40} className="delete_icon" onClick={() => remove(index)} />
                    // </Button>
                  )}
                  
                </InputGroup>
                {errors.emails?.[index]?.email && (
                  <span style={{ color: "maroon" }}>{errors.emails[index].email.message}</span>
                )}
                </div>
                  
                ))}
                {/* {(fields.length < (maxWorkers - workers.length) || fields.length < 20) && ( */}
                {(fields.length < 10) && (
                  <InputGroup>
                    <IoAddCircle size={40} className="add_icon" onClick={() => append({ email: "" })}/>
                  </InputGroup>
                )}
              
                <InputGroup>
                  <Button type="submit" onClick={handleSubmit(onRegisterPressed)} 
                    disabled={loadingForm}>{loadingForm ? 
                      <>
                        {t('signup.loading')} <Spinner animation="border" size="sm" />
                      </> : 
                      t("signup.register")}</Button>
                </InputGroup>

            </Container>
            <Container style={{alignContent: 'center', textAlign: 'center'}}>
              { workers.length > 0 &&
                <>
                <Container>
                  <h5>{t('worker.workers_list_title')}</h5>
                </Container>
                {workers.map((email, index) => (
                  <Container key={index}>
                    <p>{email} <IoTrash size={40} className="delete_icon" onClick={() => removeWorker(user.comId, email)} /></p>
                  </Container>
                ))}
                </>
              }
            </Container>
          </Form>
        </div>
      </div>
    </>
  );
};

export default CreateWorkersView;


